/*
 * Normalize custom line-item property text before add-to-cart.
 * Whitespace-only values (e.g. " ") become distinct Shopify line-item
 * properties from an empty message, so the same product splits into two rows.
 */
(function () {
  function normalizePropertyTextFields(scope) {
    var root = scope || document;
    var fields = root.querySelectorAll(
      '.custom-option__text-input, textarea[name^="properties["], input[type="text"][name^="properties["]'
    );

    fields.forEach(function (el) {
      if (!el || el.disabled) return;
      var trimmed = String(el.value || '').trim();
      if (el.value !== trimmed) el.value = trimmed;
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn =
        event.target.closest &&
        event.target.closest(
          '.product-purchase-form [type="submit"], .product-area__add-to-cart-xs button'
        );
      if (!btn) return;
      normalizePropertyTextFields(document);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      normalizePropertyTextFields(form);
      // Custom option fields can sit outside the <form> via the form= attribute.
      normalizePropertyTextFields(document);
    },
    true
  );
})();
